// Stored answers keep the durable API URL. Preview/download requests use the
// current API origin, including the loopback gateway used by local devices.
export const resolveSurveyFileUrl = (content: string, apiBaseUrl: string): string => {
  const path = content?.match(/^(?:https?:\/\/[^/]+)?(\/api\/ms\/client\/survey-images\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\?[^#]*)?)$/i)?.[1];
  return path ? `${apiBaseUrl.replace(/\/$/, '')}${path}` : content;
};
